import * as React from 'react';

// Interfaces
import { ICourse } from 'store/StateInterfaces';

// Components
import CourseDeleteModal from 'Screens/CoursesList/Common/Components/CourseDeleteModal';

// Assets
import '../../Common/Assets/course.sass';


interface IProps {
    course: ICourse;
    infoUrl: string;
    start_msg: string;
    courseUrl: string;
    unRegister: () => void;
};

const Course = (props: IProps) => {
    let course = props.course;
    let formatter = new Intl.DateTimeFormat("en-GB", {
        year: "numeric",
        month: "2-digit",
        day: "2-digit"
    });
    let start_date = '';
    try {
        start_date = formatter.format(Date.parse(course.start_date))
    }
    catch (e) {
        console.log(e);
    }
    return (
        <div className="dashboard col-md-3 col-sm-4">
            <div className="dashboard-container  db-student" id={`${course.id}`}>
                <div className="db-info" onClick={() => handleClicks(props)} >
                    <div className="opacity"></div>
                    <div className="db-info-label">
                        {course.enrollment_type == "O" ? "Open Course" : "Moderated Course"}
                        <span
                            // data-toggle="tooltip" 
                            title={course.enrollment_type == "O" ? "Course open to public." : "Course open only to approved students."}
                            // style={{font-size:1rem}}
                            className="material-icons icon info-icon">help_outline</span>
                    </div>
                    <div className="db-userInfo"> S</div>
                    <div className="db-courseImageContainer">
                        {course.image ? (<img className="courseImage" src={course.image} />) : (
                            <img className="courseImage" src={"/static/img/no_image.png"} />
                        )}
                    </div>
                </div>

                <div className="db-courseLabel" title={course.title} onClick={() => handleClicks(props)} >{course.courseCode}: {course.title}</div>
                {(course.enrollment_status == "P") ? (
                    <div className="row">
                        <div className="db-pendingStatus col-sm-10">Enrollment Pending</div>
                        <CourseDeleteModal
                            label={`label${props.course.id}`}
                            modal={`modal${props.course.id}`}
                            title={props.course.title}
                            modalTitle='Confirm unregistration'
                            warningMsg='Are you sure about deleting '
                            callback={props.unRegister} />
                        <a className="material-icons icon db-delete col-sm-2 btn btn-sm" data-toggle='modal' href={`#modal${props.course.id}`} >
                            delete
                        </a>
                    </div>
                ) : (<>
                    <CourseDeleteModal
                        label={`label${props.course.id}`}
                        modal={`modal${props.course.id}`}
                        title={props.course.title}
                        modalTitle='Confirm unregistration'
                        warningMsg='Sure about unregistering from '
                        callback={props.unRegister} />
                    <a className="btn btn-sm db-publish" data-toggle='modal' href={`#modal${props.course.id}`} >
                        UnRegister
                    </a>
                </>
                    )}


                <div className="d-flex flex-row db-footerLabel">
                    <div style={{ width: '50%' }}>
                        <span className="db-courseCreated">From <span title={course.institute?.name} className="db-institute">{course.institute?.name != null ? course.institute?.name : "Other"}</span></span>
                    </div>
                    <div style={{ width: '50%' }}>
                        <span className="db-courseUpdated">Created {start_date != "" ? start_date : "01/01/2020"}</span>
                    </div>
                </div>
                {/* <div className="db-footerLabel db-offeredBy">
                    <span className=""> Offered by:</span>
                    <span className="db-institute"> {course.institute.name}</span>
                </div> */}
            </div>
        </div>
    )
}

const handleClicks = (props) => {
    window.location.href = `/courseware/course/${props.course.id}/`;
};
export default Course;
